import { Button, Form, message, Select } from "antd";
import React, { useEffect, useState } from "react";
import { professionalService, userService } from "../_services";
const { Option } = Select;

export const MapPoliceStation = () => {
  const [districts, setDistricts] = useState([]);
  const [form] = Form.useForm();
  const logout = () => {
    userService.logout();
  };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    professionalService.getDistrict(user.cityId).then((res) => {
      setDistricts(res.pc_districts);
      if (user && Array.isArray(user.map_districtId)) {
        form.setFieldsValue({ map_districtId: user.map_districtId });
      }
    });
  }, [form]);

  const handleDisctictChange = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    let obj = {
      map_districtId: form.getFieldValue("map_districtId"),
    };
    userService.saveMapPoliceStation(user.id, obj).then((res) => {
      message.success(res.message);
      logout();
    });
  };

  return (
    <div>
      <Form form={form}>
        <Form.Item
          name="map_districtId"
          rules={[
            {
              required: true,
              message: "Please select Unit",
            },
          ]}
        >
          <Select
            placeholder="Please select Unit"
            mode="multiple"
          >
            {districts &&
              districts.length > 0 &&
              districts.map((res) => (
                <Option key={res.id} value={res.id}>
                  {res.DistrictName}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Button type="primary" onClick={handleDisctictChange}>
          Save
        </Button>
      </Form>
    </div>
  );
};
